import React from "react";
// Components
import ServiceBox from "../Elements/ServiceBox";

export default function Services() {
  const services = [
    {
      name: 'Grabungsarbeiten'
    },
    {
      name: 'Abriss- & Abbrucharbeiten'
    },
    {
      name: 'Baustellentransporte'
    },
    {
      name: 'Biotope & Pools'
    },
    {
      name: 'Baugrubenaushub'
    },
    {
      name: 'Geländeausformungen'
    },
    {
      name: 'Künettengrabungen (Strom, Wasser & Gas)'
    },
    {
      name: 'Humusierung'
    },
    {
      name: 'Steinmauern'
    },
    {
      name: 'Straßenbau'
    },
    {
      name: 'Rodungen'
    },
    {
      name: 'Anschüttung'
    },
    {
      name: 'Eisenbahn, Unterstützungsarbeiten'
    },
    {
      name: 'Materialanschüttung zur besseren landwirtschaftlichen Nutzung'
    }
  ];

  return (
    <section id="services" className="w-full bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-6">
          <h1 className="text-2xl md:text-3xl font-extrabold">Alle wichtigen Serviceleistungen aus einer Hand.</h1>
          <h4 className="text-sm md:text-base font-semibold mt-4">Wir erfüllen auch anspruchsvollste Anforderungen mit einem Angebot zahlreicher Serviceleistungen. Ihre Zufriedenheit hat für uns stets höchste Priorität. </h4>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {services.map((item, index) => (
            <div key={index} className="w-full">
              <ServiceBox title={item.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
